import React from "react";
import { Route, Routes } from "react-router-dom";
import CheckboxLabels from "../Pages/Masters/Roles and Permissions/Filters/Checkbox";
import FilterPage from "../Components/Masters/Filter/FilterPage";
import EnvironmentDashboard from "../Pages/Environment";
import LoginWelcomePage from "../Pages/Login/LoginWelcome";
import ResetPAssword from "../Pages/Login/NewPassword";
import Overview from "../Pages/Overview";
import WaterManagementDashboard from "../Pages/Scope3/WaterManagement/Dashboard/Dashboard";
import MisReportList from "../Pages/MisReport/ReportList/MisReportList";
import MisReportCard from "../Pages/MisReport/ReportCard";
import Homepage from "../Pages/Homepage";
import CreatePassword from "../Pages/Login/CreatePassword";
import TermsOfServices from "../Pages/Policies/TermsOfServices";
import PolicyPage from "../Pages/Policies/PolicyPage";
import Maintenance from "../Pages/Maintenance/Maintenance";
import ProductionRevenue from "../Pages/Production & Revenue Info/List";
import Welcome from "../Pages/Welcome/Welcome";
import GhgList from "../Pages/GhgReport/GhgList/GhgList";
import GhgReport from "../Pages/GhgReport/GhgReport";

export const MainRoutes = [
  { path: "/", element: <Homepage /> },
  { path: "/maintenance", element: <Maintenance /> },
  { path: "/master/filter/checkbox", element: <CheckboxLabels /> },
  { path: "master/role/filter", element: <FilterPage /> },
  { path: "/dashboard", element: <Overview /> },
  { path: "/environment/dashboard", element: <EnvironmentDashboard /> },
  { path: "/login", element: <LoginWelcomePage /> },
  { path: "/reset-password/:token", element: <ResetPAssword /> },
  { path: "/create-password/:token", element: <CreatePassword /> },
  { path: "/policy", element: <PolicyPage /> },
  { path: "/terms-&-services", element: <TermsOfServices /> },
  { path: "/production-revenue", element: <ProductionRevenue /> },
  {
    path: "/water-management/dash-board",
    element: <WaterManagementDashboard />,
  },
  { path: "/mis-report", element: <MisReportList /> },
  { path: "/mis-report/:id", element: <MisReportCard /> },
  { path: "/ghg-report", element: <GhgList /> },
  { path: "/ghg-report/:id", element: <GhgReport /> },
  { path: "/welcome", element: <Welcome /> },
];
